module.exports = __webpack_public_path__ + "static/media/loader.eab406db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.svg
// module id = 31
// module chunks = 0